<div class="box-content rd-widget widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <div class="table-part">
    <table data-id="widgetLocalMarketData" class="widget-large widgetLocalMarketData cellspacing-0 cellpadding-0" aria-hidden="true">
      <thead>
        <tr class="widget-ruller-large">
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-space">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
        </tr>
      </thead>
      <tr class="red-line">
        <td colspan="10">
          <widget-label [widget]="this" [color]="'white'" [fieldName]="'labelLocalMarketData'" [align]="'left'" [bold]="true"></widget-label>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="4">
          <widget-label [color]="'white'" [widget]="this" [fieldName]="'primaryUse'" [align]="'right'" [bold]="true"></widget-label>
        </td>
        <td colspan="2" class="space">&nbsp;</td>
        <td colspan="4">
          <input *ngIf="editMode" type="text" [(ngModel)]="widgetData.primaryUse" class="widget-input-text gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          <widget-value *ngIf="!editMode" [align]="'left'" [color]="'white'" [bold]="true">{{widgetData.primaryUse}}</widget-value>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="4">
          <widget-label [color]="'white'" [widget]="this" [fieldName]="'marketGeography'" [align]="'right'" [bold]="true"></widget-label>
        </td>
        <td colspan="2" class="space">&nbsp;</td>
        <td colspan="5">
          <input *ngIf="editMode" type="text" [(ngModel)]="widgetData.marketGeography" class="widget-input-text gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          <widget-value *ngIf="!editMode" [align]="'left'" [color]="'white'" [bold]="true">{{widgetData.marketGeography}}</widget-value>
        </td>
      </tr>
      <tr *ngIf="editMode" class="light-grey-line">
        <td colspan="5"><widget-label [widget]="this" [fieldName]="'primeRent'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="3">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.primeRent" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="2">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_local_market_data_arrows']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.primeRentArrow"
                              (ngModelChange)="setDirtyFlag(true)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>&nbsp;</span>
              <svg-icon *ngIf="dataItem.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <svg-icon *ngIf="dataItem?.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
          </kendo-dropdownlist>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="7"><widget-label [widget]="this" [fieldName]="'averageRent'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="2">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.averageRent" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="2">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_local_market_data_arrows']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.averageRentArrow"
                              (ngModelChange)="setDirtyFlag(true)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>&nbsp;</span>
              <svg-icon *ngIf="dataItem.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <svg-icon *ngIf="dataItem?.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
          </kendo-dropdownlist>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'vacancyRate'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="2">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.vacancyRate" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="2">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_local_market_data_arrows']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.vacancyRateArrow"
                              (ngModelChange)="setDirtyFlag(true)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>&nbsp;</span>
              <svg-icon *ngIf="dataItem.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <svg-icon *ngIf="dataItem?.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr *ngIf="!editMode" class="light-grey-line">
        <td colspan="5"><widget-label [widget]="this" [fieldName]="'primeRent'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="4" *ngIf="(widgetData.primeRent || 0) == 0"><widget-value [align]="'right'">{{'common.notAvailable' | rdTranslate}}</widget-value></td>
        <td colspan="4" *ngIf="(widgetData.primeRent || 0) != 0">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{ widgetData.primeRent | rdLocalizedNumber:2:false:'':'':0 }} {{currency}}/{{unitOfLength}}²/year</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{ widgetData.primeRent | rdLocalizedNumber:2:false:'':'':0 }} {{currency}}/{{unitOfLength}}²/month</widget-value>
        </td>
        <td colspan="1">
          <div class="arrow-image-container">
            <div *ngIf="widgetData.primeRentArrow == 1">&#9650;</div>
            <div *ngIf="widgetData.primeRentArrow == 2">&#9660;</div>
            <div *ngIf="widgetData.primeRentArrow == 3" class="arrow-image-right">&#9650;</div>
          </div>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="5"><widget-label [widget]="this" [fieldName]="'averageRent'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="4" *ngIf="(widgetData.averageRent || 0) == 0"><widget-value [align]="'right'">{{'common.notAvailable' | rdTranslate}}</widget-value></td>
        <td colspan="4" *ngIf="(widgetData.averageRent || 0) != 0">
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 1">{{ widgetData.averageRent | rdLocalizedNumber:2:false:'':'':0 }} {{currency}}/{{unitOfLength}}²/year</widget-value>
          <widget-value [align]="'right'" *ngIf="widgetData.displayValuesOverTimeId == 2">{{ widgetData.averageRent | rdLocalizedNumber:2:false:'':'':0 }} {{currency}}/{{unitOfLength}}²/month</widget-value>
        </td>
        <td colspan="1">
          <div class="arrow-image-container">
            <div *ngIf="widgetData.averageRentArrow == 1">&#9650;</div>
            <div *ngIf="widgetData.averageRentArrow == 2">&#9660;</div>
            <div *ngIf="widgetData.averageRentArrow == 3" class="arrow-image-right">&#9650;</div>
          </div>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="5"><widget-label [widget]="this" [fieldName]="'vacancyRate'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="4" *ngIf="(widgetData.vacancyRate || 0) == 0"><widget-value [align]="'right'">{{'common.notAvailable' | rdTranslate}}</widget-value></td>
        <td colspan="4" *ngIf="(widgetData.vacancyRate || 0) != 0"><widget-value [align]="'right'">{{ widgetData.vacancyRate | rdLocalizedNumber:2:false:'':'':0 }} %</widget-value></td>
        <td colspan="1">
          <div class="arrow-image-container">
            <div *ngIf="widgetData.vacancyRateArrow == 1">&#9650;</div>
            <div *ngIf="widgetData.vacancyRateArrow == 2">&#9660;</div>
            <div *ngIf="widgetData.vacancyRateArrow == 3" class="arrow-image-right">&#9650;</div>
          </div>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
      </tr>
      <tr *ngIf="editMode" class="white-line">
        <td colspan="5"><widget-label [widget]="this" [fieldName]="'marketTakeup'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="3">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.marketTakeup" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="2">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_local_market_data_arrows']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.marketTakeupArrow"
                              (ngModelChange)="setDirtyFlag(true)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>&nbsp;</span>
              <svg-icon *ngIf="dataItem.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <svg-icon *ngIf="dataItem?.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
          </kendo-dropdownlist>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="7"><widget-label [widget]="this" [fieldName]="'marketImmediateSupply'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="2">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.marketImmediateSupply" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="2">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_local_market_data_arrows']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.marketImmediateSupplyArrow"
                              (ngModelChange)="setDirtyFlag(true)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>&nbsp;</span>
              <svg-icon *ngIf="dataItem.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <svg-icon *ngIf="dataItem?.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
          </kendo-dropdownlist>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="6"><widget-label [widget]="this" [fieldName]="'market24MonthsPipeline'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="2">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.market24MonthsPipeline" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="2">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_local_market_data_arrows']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.market24MonthsPipelineArrow"
                              (ngModelChange)="setDirtyFlag(true)">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>&nbsp;</span>
              <svg-icon *ngIf="dataItem.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <svg-icon *ngIf="dataItem?.oid == 0" src='' class="caret-icon"
                        title="none" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 1" src='./assets/icons/caret-up-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="up" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 2" src='./assets/icons/caret-down-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="down" align='center'></svg-icon>
              <svg-icon *ngIf="dataItem?.oid == 3" src='./assets/icons/caret-forward-outline.svg' class="caret-icon svg-icon-black svg-icon-dropdown-report-designer"
                        title="right" align='center'></svg-icon>
            </ng-template>
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr *ngIf="!editMode" class="white-line">
        <td colspan="5"><widget-label [widget]="this" [fieldName]="'marketTakeup'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="4" *ngIf="(widgetData.marketTakeup || 0) == 0"><widget-value [align]="'right'">{{ 'common.notAvailable' | rdTranslate }}</widget-value></td>
        <td colspan="4" *ngIf="(widgetData.marketTakeup || 0) != 0"><widget-value [align]="'right'">{{ (widgetData.marketTakeup | number:'1.0-0') === '0' ? '' : (widgetData.marketTakeup | number:'1.0-0') }} {{ unitOfLength }}²</widget-value></td>
        <td colspan="1">
          <div class="arrow-image-container">
            <div *ngIf="widgetData.marketTakeupArrow == 1">&#9650;</div>
            <div *ngIf="widgetData.marketTakeupArrow == 2">&#9660;</div>
            <div *ngIf="widgetData.marketTakeupArrow == 3" class="arrow-image-right">&#9650;</div>
          </div>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="5"><widget-label [widget]="this" [fieldName]="'marketImmediateSupply'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="4" *ngIf="(widgetData.marketImmediateSupply || 0) == 0"><widget-value [align]="'right'">{{ 'common.notAvailable' | rdTranslate }}</widget-value></td>
        <td colspan="4" *ngIf="(widgetData.marketImmediateSupply || 0) != 0"><widget-value [align]="'right'">{{ (widgetData.marketImmediateSupply | number:'1.0-0') === '0' ? '' : (widgetData.marketImmediateSupply | number:'1.0-0') }} {{ unitOfLength }}²</widget-value></td>
        <td colspan="1">
          <div class="arrow-image-container">
            <div *ngIf="widgetData.marketImmediateSupplyArrow == 1">&#9650;</div>
            <div *ngIf="widgetData.marketImmediateSupplyArrow == 2">&#9660;</div>
            <div *ngIf="widgetData.marketImmediateSupplyArrow == 3" class="arrow-image-right">&#9650;</div>
          </div>
        </td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="5"><widget-label [widget]="this" [fieldName]="'market24MonthsPipeline'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="4" *ngIf="(widgetData.market24MonthsPipeline || 0) == 0"><widget-value [align]="'right'">{{ 'common.notAvailable' | rdTranslate }}</widget-value></td>
        <td colspan="4" *ngIf="(widgetData.market24MonthsPipeline || 0) != 0"><widget-value [align]="'right'">{{ (widgetData.market24MonthsPipeline | number:'1.0-0') === '0' ? '' : (widgetData.market24MonthsPipeline | number:'1.0-0') }} {{ unitOfLength }}²</widget-value></td>
        <td colspan="1">
          <div class="arrow-image-container">
            <div *ngIf="widgetData.market24MonthsPipelineArrow == 1">&#9650;</div>
            <div *ngIf="widgetData.market24MonthsPipelineArrow == 2">&#9660;</div>
            <div *ngIf="widgetData.market24MonthsPipelineArrow == 3" class="arrow-image-right">&#9650;</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
